//
//
//
//
//
//
//

import FeedBack from './pages/common/Feedback'

import { mapActions } from 'vuex'
export default {
  name: 'app',
  mounted () {
    // 解决iOS下:active无效果的问题
    document.body.addEventListener('touchstart', function () {})
  },
  methods: {
    ...mapActions([
      'commitData'
    ]),
    feedback (id) {
      this.commitData({
        request: 'contact/kefu',
        path: 'user/customer',
        data: {
          type: id
        },
        onSuccess: () => {
          wx.closeWindow()
        },
        onFail: (error) => {
          this.checkError(error.msg)
        }
      })
    },
    checkError (error) {
      this.$vux.toast.show({
        time: 3000,
        width: 'auto',
        type: 'cancel',
        text: error
      })
    }
  },
  components: {
    [FeedBack.name]: FeedBack
  }
}



// WEBPACK FOOTER //
// ./src/App.vue